import React from 'react';
import styled from 'ui/styled';

const StyledCheckbox = styled.span<{ checked: boolean }>`
  width: 25px;
  flex-shrink: 0;
  height: 25px;
  box-shadow: rgb(66, 133, 244) 0px 0px 0px 1px inset;
  border-radius: 3px;
  transition: background-color 0.15s ease 0s, transform 0.15s ease;
  margin-right: 10px;
  display: flex;
  margin-top: 5px;
  background: transparent;
  position: relative;
  
  &:focus {
    box-shadow: rgb(26, 101, 248) 0px 0px 0px 1px;
  }

  &:after {
    display: block;
    content: "";
    width: 6px;
    height: 11px;
    transform: scale(1.5) rotate(40deg);
    border-style: solid;
    border-color: white;
    border-image: initial;
    border-width: 0px 2px 2px 0px;
    transition: opacity 0.15s ease 0s, transform 0.15s ease 0s;
    transform: scale(1) rotate(40deg);
    position: absolute;
    top: 5px;
    left: 8px;

    opacity: ${({ checked }) => checked ? `1` : '0'};
  }

  ${({ checked }) => checked ? `background: rgb(66, 133, 244);` : ''}
`;

export function Checkbox({ checked }: { checked: boolean }) {
  return (
    <StyledCheckbox checked={checked} aria-checked={checked} role="checkbox" tabIndex={0} />
  )
}